import { createElement, type ElementType, type ReactNode } from 'react';

type Gap = 1 | 2 | 3 | 4 | 5 | 6 | 8 | 12;

type StackProps<T extends ElementType = 'div'> = {
  children: ReactNode;
  gap?: Gap;
  as?: T;
  className?: string;
} & Omit<React.ComponentPropsWithoutRef<T>, 'children' | 'className'>;

export function Stack<T extends ElementType = 'div'>({
  children,
  gap = 4,
  as,
  className,
  ...rest
}: StackProps<T>) {
  const cls = `ds-stack ds-stack--gap-${gap}${className ? ` ${className}` : ''}`;
  return createElement(as ?? 'div', { className: cls, ...rest }, children);
}
